import { useState } from 'react'
import type { FormSchema } from '../lib/api.ts'

export function ToolForm({ schema, submitting, onSubmit }: {
  schema: FormSchema; submitting: boolean; onSubmit: (data: Record<string, string>) => void
}) {
  const [values, setValues] = useState<Record<string, string>>({})
  const set = (name: string, v: string) => setValues((s) => ({ ...s, [name]: v }))

  function submit(e: React.FormEvent) {
    e.preventDefault()
    for (const f of schema.fields) {
      if (f.required && !(values[f.name] ?? '').trim()) return
    }
    onSubmit(values)
  }

  return (
    <form className="panel form" onSubmit={submit}>
      {schema.fields.map((f) => (
        <label key={f.name} className="field">
          <span className="field__label">{f.label}</span>
          {f.type === 'textarea' ? (
            <textarea
              className="input textarea"
              value={values[f.name] ?? ''}
              placeholder={f.placeholder}
              onChange={(e) => set(f.name, e.target.value)}
            />
          ) : f.type === 'select' ? (
            <div className="select-wrap">
              <select
                className="input select"
                value={values[f.name] ?? ''}
                onChange={(e) => set(f.name, e.target.value)}
              >
                <option value="">Select…</option>
                {(f.options ?? []).map((o) => (
                  <option key={o} value={o}>{o}</option>
                ))}
              </select>
            </div>
          ) : (
            <input
              type={f.type}
              className="input"
              value={values[f.name] ?? ''}
              placeholder={f.placeholder}
              onChange={(e) => set(f.name, e.target.value)}
            />
          )}
        </label>
      ))}
      <button className="btn btn--primary btn--block" type="submit" disabled={submitting}>
        {submitting ? (
          <>
            <span className="dots" aria-hidden="true"><i></i><i></i><i></i></span>
            {' '}Generating…
          </>
        ) : (
          'Generate'
        )}
      </button>
    </form>
  )
}
